<template>
  <div :class="componentClassName">
    <a-page-heading>アカウント情報確認・変更</a-page-heading>

    <m-section>
      <m-action-card title="SMS認証用電話番号編集" icon="sms-phone" :narrow-body="true">
        <div v-if="isOTPSent" class="t-profile-edit-sms__notice">
          「{{ phoneNumber }}」宛にSMSを送信いたしました。メッセージ内に記載されたコードを入力してください。
        </div>
        <form ref="form" class="t-profile-edit-sms__form" @submit.prevent="handleFormSubmit">
          <div class="t-profile-edit-sms__fields">
            <m-form-input v-if="!isOTPSent" label="SMS認証用電話番号">
              <a-text-field v-model="userData.phone_number" type="number" placeholder="08012345678" />
            </m-form-input>
            <template v-if="isOTPSent">
              <m-form-input label="SMS認証コードの入力">
                <a-text-field v-model="userData.otp" type="number" />
              </m-form-input>
              <a-caption-list class="t-profile-edit-sms__remark">
                <li>認証コードが届かない場合には以下より、再送をお試しください</li>
                <li>
                  数回試しても認証コードが届かない場合は、前の画面から入力した電話番号が正しいか確認をお願いします
                </li>
              </a-caption-list>
            </template>
          </div>
          <m-form-action-buttons v-if="!isOTPSent" class="t-profile-edit-sms__buttons">
            <a-button variant="block" color="primary" @click="handleSendOTPClick"> 認証コードを送る </a-button>
            <a-button variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
          </m-form-action-buttons>
          <m-form-action-buttons v-if="isOTPSent" class="t-profile-edit-sms__buttons">
            <a-button variant="block" color="primary" submit="submit">保存</a-button>
            <a-button variant="outlined" color="primary" @click="handleSendOTPClick"> 認証コードを再送する </a-button>
            <a-button color="primary" class="t-profile-edit-sms__button-optional" @click="handleBackClick">
              戻る
            </a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="profileEditPsms_completedModal"
      v-model:visible="dialogVisible"
      class="o-modal-authentication-completed"
      footer-variant="confirmation"
      width="422px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseModal"
    >
      <template #title>認証完了</template>
      <a-text :center="true"> SMS番号の認証・登録が完了しました。 </a-text>
      <template #footer>
        <a-button variant="outlined" color="primary" label="閉じる" size="small" @click="handleCloseModalClick" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ACaptionList from '@/components/atoms/caption-list';
import OModal from '@/components/organisms/modal';
import AText from '@/components/atoms/text';
import { cloneDeep } from 'lodash';

export default {
  name: 't-profile-edit-sms',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    MFormInput,
    ATextField,
    ACaptionList,
    OModal,
    AText,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    isOTPSent: {
      type: Boolean,
      default: false,
    },
    isAuthenticationCompleted: {
      type: Boolean,
      default: false,
    },
    handleSendVerificationCodeClick: {
      type: Function,
      default: () => {},
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
    handleSaveClick: {
      type: Function,
      default: () => {},
    },
    handleBackClick: {
      type: Function,
      default: () => {},
    },
    handleCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: {
        phone_number: '',
        otp: '',
      },
      dialogVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-profile-edit-sms');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    isAuthenticationCompleted(val) {
      this.dialogVisible = true;
    },
  },
  mounted() {
    if (this.isAuthenticationCompleted) {
      this.dialogVisible = true;
    }
  },
  methods: {
    handleSendOTPClick() {
      const userData = cloneDeep(this.userData);
      const payload = {
        phone_number: this.isOTPSent ? this.phoneNumber : userData.phone_number,
      };
      this.handleSendVerificationCodeClick(payload);
    },
    handleFormSubmit(event) {
      event.preventDefault();
      const userData = cloneDeep(this.userData);
      const payload = {
        otp: userData.otp,
      };
      this.handleSaveClick(payload);
    },
    handleCloseModalClick() {
      this.dialogVisible = false;
    },
  },
};
</script>
